import {EMessageMatcherButtonTypes} from 'src/containers/MessageMatchers/definitions';

import {
  EDeliveryStatus,
  EDirection,
  EMessageSource,
  ETrafficType,
  IncomingMessageStatus,
} from './definitions';

export default {
  filter: {
    period: 'Временной интервал',
    phone: 'Быстрый поиск по номеру телефона или идентификатору',
    channelType: 'Канал',
    deliveryStatus: 'Статус исходящего сообщения',
    broadcasts: 'Название рассылки',
    cascades: 'Название каскада',
    trafficType: 'Тип трафика',
    direction: 'Направленность трафика',
    subjects: 'Канал',
    initiator: 'Инициатор рассылки',
    source: 'Источник отправки сообщения',
    actions: 'Взаимодействие с сообщением',
    actionsHint:
      'Фильтр применяется к сообщениям Viber и WhatsApp с типом контента «Кнопка-ссылка» и параметром «Переход по кнопке-ссылке». Этот параметр отображается у сообщений, если при создании рассылки выбрана настройка «Отслеживать переходы по кнопкам-ссылкам» или выбран шаблон с этой настройкой.',
    isClicked: 'Переход по кнопке-ссылке',
  },
  searchMessages: 'Поиск сообщений',
  messagesByCriteria: 'Сообщений по критериям – {{count, number}}',
  button: {
    downloadList: 'Выгрузить список',
  },
  list: {
    head: {
      sendDateTime: 'Дата и время\nотправки',
      deliveryStatus: 'Статус\nсообщения',
      recipient: 'Получатель',
      sender: 'Канал',
      traffic: 'Трафик',
      inout: 'ВХ/ИСХ',
      content: 'Контент',
      source: 'Источник',
    },
    loading: 'загружаем список',
  },
  sourceHint: {
    [EMessageSource.DIALOG]: '<0>Диалоги</0> — раздел в кабинете edna Pulse',
    [EMessageSource.FLOW]: '<0>Сценарий</0> — функция «Сценарии edna Pulse»',
    [EMessageSource.IMHPX]: '<0>Chat Center</0> — личный кабинет edna Chat Center',
    [EMessageSource.JIVO]: '<0>Jivo</0> — платформа Jivo',
    [EMessageSource.BROADCAST]: '<0>Личный кабинет</0> — личный кабинет edna Pulse',
    [EMessageSource.JSON_API]: '<0>API</0> — API edna Pulse',
    [EMessageSource.INTERNAL_API]: '<0>Тест</0> — функция «Протестировать рассылку»',
    [EMessageSource.WHATSAPP_BUSINESS_APP]:
      '<0>WhatsApp Business App</0> — устройство WhatsApp Business',
  },
  source: {
    [EMessageSource.DIALOG]: 'Диалоги',
    [EMessageSource.FLOW]: 'Сценарий',
    [EMessageSource.IMHPX]: 'Chat Center',
    [EMessageSource.JIVO]: 'Jivo',
    [EMessageSource.BROADCAST]: 'Личный кабинет',
    [EMessageSource.JSON_API]: 'API',
    [EMessageSource.OUT_MESSAGE]: 'API',
    [EMessageSource.INTERNAL_API]: 'Тест',
    [EMessageSource.BROADCAST_TEST_MESSAGE]: 'Тест',
    [EMessageSource.WHATSAPP_BUSINESS_APP]: 'WhatsApp Business App',
  },
  status: {
    [EDeliveryStatus.ENQUEUED]: 'Ожидает',
    [EDeliveryStatus.SENT]: 'Отправлено',
    [EDeliveryStatus.FAILED]: 'Не отправлено',
    [EDeliveryStatus.ACCEPTED]: 'Не отправлено',
    [EDeliveryStatus.INVALID]: 'Не отправлено',
    [EDeliveryStatus.DELIVERED]: 'Доставлено',
    [EDeliveryStatus.CANCELLED]: 'Отменено',
    [EDeliveryStatus.UNDELIVERED]: 'Не доставлено',
    [EDeliveryStatus.READ]: 'Прочитано',
    [EDeliveryStatus.EXPIRED]: 'Просрочено',
    [EDeliveryStatus.BLOCKED]: 'Заблокировано',
    [EDeliveryStatus.SUSPENDED]: 'Приостановлено',
    [IncomingMessageStatus.RECEIVED]: 'Получено',
  },
  trafficType: {
    [ETrafficType.AD]: 'Рекламный',
    [ETrafficType.MULTINAMING]: 'Рекламный',
    [ETrafficType.SERVICE]: 'Сервисный',
    [ETrafficType.HSM]: 'Шаблонные WhatsApp',
    [ETrafficType.CHAT]: 'Нешаблонные WhatsApp',
  },
  trafficTypeShort: {
    [ETrafficType.AD]: 'Рекл',
    [ETrafficType.SERVICE]: 'Серв',
    [ETrafficType.HSM]: 'Шабл.',
    [ETrafficType.CHAT]: 'Нешабл.',
  },
  direction: {
    [EDirection.IN]: 'Входящий',
    [EDirection.OUT]: 'Исходящий',
  },
  directionShort: {
    [EDirection.IN]: 'ВХ',
    [EDirection.OUT]: 'ИСХ',
  },
  content: {
    headerText: 'Заголовок сообщения',
    operator: 'Оператор получателя',
    text: 'Текст сообщения',
    footerText: 'Подпись сообщения',
    securityAdvice: 'Рекомендации по безопасности',
    codeExpirationMinutes: '<0>Срок действия пароля (мин):</0> {{minutes}}',
    image: 'Изображение',
    video: 'Видео',
    audio: 'Аудио',
    document: 'Файл',
    location: 'Геометка',
    name: 'Название',
    link: 'Ссылка',
    links: 'Ссылки',
    buttonText: 'Текст кнопки',
    value: 'Значение',
    coordinates: 'Координаты',
    error: 'Ошибка',
    broadcast: 'Рассылка',
    cascade: 'Каскад',
    segments: 'Сегментов',
    menu: 'Меню',
    buttons: 'Кнопки',
    contact: 'Контакт',
    firstName: 'Имя',
    lastName: 'Фамилия',
    phone: 'Телефон',
    subtitle: 'Подзаголовок',
    sender: 'Отправитель',
    recipientUID: 'UID получателя',
    deviceAddress: 'deviceAddress получателя',
    deviceModel: 'Модель устройства получателя',
    referral: 'Referral',
    locationButtonText: 'Место',
    linkClick: 'Переход по кнопке-ссылке',
    clickedLinkHint: 'Ссылка для редиректа',
    hasLinkClick: 'Есть переход',
    noLinkClick: 'Нет перехода',
    initiator: 'Инициатор',
    flowId: 'Flow ID',
    flowResponse: 'WA Flow Response',
    requestCallPermission: 'Запрос звонка',
    replyButton: 'Кнопка-быстрый ответ',
  },
  requestCallPermission: {
    1: 'Разрешить звонки',
    2: 'Временно разрешить звонки',
    3: 'Не разрешать',
  },
  buttonType: {
    [EMessageMatcherButtonTypes.CONTACT]: 'Запрос контакта',
    [EMessageMatcherButtonTypes.LOCATION]: 'Запрос локации',
    [EMessageMatcherButtonTypes.TEXT]: 'Кнопка-текст',
    [EMessageMatcherButtonTypes.CALLBACK]: 'Быстрый ответ',
    [EMessageMatcherButtonTypes.URL]: 'Кнопка-ссылка',
  },
  noDataWithFilters: {
    title: 'Увы, мы ничего не нашли',
    text: 'Сообщений по выбранным фильтрам нет',
    hint: 'Проверьте, возможно вы ошиблись где-то в настройках или забыли поставить правильный временной интервал',
    button: 'Попробовать еще раз',
  },
  noData: {
    title: 'Здесь пока пусто',
    text: 'После того как вы запустите первую рассылку, здесь появятся данные об отправленных сообщениях. А до тех пор мы можем только предложить вам попробовать создать рассылку',
    button: 'В рассылки',
  },
  referral: {
    // TODO нужен перевод на русский?
    body: 'Body',
    headline: 'Headline',
    sourceId: 'SourceID',
    sourceType: 'SourceType',
    sourceUrl: 'SourceURL',
  },
  orderProduct: {
    product: 'Message Business',
    catalogId: 'catalog_id:',
    productId: 'product_retailer_id:',
    order: 'Placing an Order',
  },
  reportGeneration: {
    title: 'Отчет по критериям',
    description:
      'Сформируйте и выгрузите собственный отчет по сообщениям согласно заданным критериям',
    period: 'Выберите период',
    phone: 'Номер телефона',
    generate: 'Сформировать отчет',
  },
  existReportModal: {
    title: 'Отчет формируется',
    description:
      'Отчет с такими критериями уже формируется. Посмотрите результат в разделе <0>«Журнал событий» → «Загрузки»</0>.',
  },
  emptyReportModal: {
    title: 'Нет данных',
    description:
      'Не удалось сформировать отчет согласно заданным критериям. Попробуйте изменить критерии',
  },
  reportGenerationInfo: 'Формируем Отчет {{name}}. <0>Посмотреть результат</0>',
};
